import React from "react";
import battle from "assets/img/battle.svg";
import ofWord from "assets/img/of.svg";
import yields from "assets/img/yields.svg";
import Footer from "./Footer";

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <main
        className="container-fluid"
        style={{ marginTop: "60px", marginBottom: "60px" }}
      >
        <p className="heading d-flex flex-column align-items-center justify-content-center flex-md-row mb-2 pt-5">
          <span>
            <img src={battle} alt="Battle" />
          </span>
          <em>
            <img src={ofWord} alt="of" />
          </em>
          <span className="mt-sm-2 mt-md-0">
            <img src={yields} alt="Yields" />
          </span>
        </p>

        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
